import React, { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

import logo from "../../assets/logo.svg"
import { fbAuth } from "../../services/Firebase"
import Toggler from "../Toggler"
import { MdPersonOutline } from "react-icons/md"
import { RiHeart2Line, RiLogoutCircleRLine } from "react-icons/ri"
import SearchComponent from "../SearchComponent"
import { useFavorite } from "../../contexts/FavoriteContext"

function Navbar({ setShowPage }) {
    const history = useHistory()
    const location = useLocation()
    const allowFavorite = useFavorite()
    const [ openModal, setOpenModal ] = useState( false )
    const [ animate, setAnimate ] = useState( false )
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    const toggleModal = () => {
        setTimeout(() => setOpenModal( !openModal ), 150)
        setAnimate( !animate )
    }

    const handleSignOut = () => {
        fbAuth.signOut().catch((error) => console.log(error))
        history.push( "/" )
    }
    
    const handleFavoriteRoute = () => history.push( "/favorite" )
    const handleHomeRoute = () => {
        !location.pathname.includes( "/recipe" ) && history.push( "/" )
        location.pathname.includes( "/favorite/recipe" ) && history.push( "/" )
    }

    return (
        <nav id="desktopNav">
            <img className="logo" src={logo} alt="Page Logo" onClick={handleHomeRoute} />
            <SearchComponent className="searchBar" setShowPage={setShowPage} />
            
            <div className="avatar" onClick={toggleModal}>
                {
                    user.isAnonymous
                        ? <MdPersonOutline title="Person Icon" size="22.5px" />
                        : <img src={user.photoURL} alt="" />
                }
                <span>{user.isAnonymous ? "Guest" : `${user.displayName?.split(" ")[0]}`}</span>
            </div>

            { 
                openModal
                &&  <div className={animate ? "modal animate" : "modal"} onMouseLeave={toggleModal}>
                    <Toggler />
                    { allowFavorite 
                            &&  <div onClick={handleFavoriteRoute}>
                                <RiHeart2Line size="22px" />
                                <span>Favorite</span>
                            </div>
                    }
                    <div onClick={handleSignOut}>
                        <RiLogoutCircleRLine size="22px" />
                        <span>Sign Out</span>
                    </div>
                </div>
            }
        </nav>
    )
}

export default Navbar
